import { render, staticRenderFns } from "./magiccube1.vue?vue&type=template&id=5e3a72b0&scoped=true"
import script from "./magiccube1.vue?vue&type=script&lang=js"
export * from "./magiccube1.vue?vue&type=script&lang=js"
import style0 from "./magiccube1.vue?vue&type=style&index=0&id=5e3a72b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a72b0",
  null
  
)

export default component.exports